module.exports = __webpack_public_path__ + "resources/img/logo_partner_game_eyegames_m.1b0802837672daa28eb421e447c76f66.png";